import type { TaskItemDetail } from '@ordr-as/ordr-service-types/epos';

type Props = {
  items: TaskItemDetail[];
  emphasized: boolean;
  orderComment?: string | null;
};

const TaskCardItems = ({ items, emphasized, orderComment }: Props) => {
  const textColor = emphasized ? 'text-brand-black' : 'text-grey-dark';

  return (
    <div className="flex flex-col gap-3">
      {items.map((item, index) => (
        <div key={item.id ?? index} className="flex flex-col gap-0.5">
          <div className="flex gap-2 items-baseline">
            <span className={`font-bold min-w-5 ${textColor}`}>{item.quantity ?? 1}×</span>
            <span className={`font-bold flex-1 ${textColor}`}>{item.itemName ?? 'Unknown item'}</span>
          </div>
          {(item.modifiers ?? []).length > 0 && (
            <ul className="m-0 p-0 pl-5 list-none flex flex-col gap-0.5">
              {(item.modifiers ?? []).map((modifier, modifierIndex) => (
                <li key={modifierIndex} className="text-small text-grey-dark flex gap-1 items-baseline">
                  <span className="text-grey-medium">→</span>
                  {modifier.itemName}
                </li>
              ))}
            </ul>
          )}
          {item.comment && <div className="pl-5 text-small italic text-grey-dark">“{item.comment}”</div>}
        </div>
      ))}
      {orderComment && <div className="text-small italic text-grey-dark">“{orderComment}”</div>}
    </div>
  );
};

export default TaskCardItems;
